import { FileItem } from '../types/files';

export const fileSystemService = {
  async getInitialDirectory(): Promise<string> {
    const result = await window.electron.ipcRenderer.invoke('get-initial-directory');
    if (result.success) {
      return result.directory;
    }
    throw new Error(result.error);
  },

  async readDirectory(dirPath: string): Promise<FileItem[]> {
    const result = await window.electron.ipcRenderer.invoke('read-directory', dirPath);
    if (result.success) {
      return result.items;
    }
    throw new Error(result.error);
  },

  async readFile(filePath: string): Promise<string> {
    const result = await window.electron.ipcRenderer.invoke('read-file', filePath);
    if (result.success) {
      return result.content;
    }
    throw new Error(result.error);
  },

  async writeFile(filePath: string, content: string): Promise<void> {
    const result = await window.electron.ipcRenderer.invoke('write-file', {
      filePath,
      content
    });
    if (!result.success) {
      throw new Error(result.error);
    }
  },

  async changeDirectory(currentDir: string, newDir: string): Promise<string> {
    const result = await window.electron.ipcRenderer.invoke('change-directory', {
      currentDir,
      newDir
    });
    if (result.success) {
      return result.newDirectory;
    }
    throw new Error(result.error);
  },

  async readDirectoryRecursive(dirPath: string): Promise<FileItem[]> {
    const items = await this.readDirectory(dirPath);
    const allItems: FileItem[] = [...items];

    for (const item of items) {
      if (item.isDirectory) {
        const subItems = await this.readDirectoryRecursive(item.path);
        allItems.push(...subItems);
      }
    }

    return allItems;
  },

  async moveFileOrFolder(sourcePath: string, destinationPath: string): Promise<void> {
    const result = await window.electron.ipcRenderer.invoke('move-file-or-folder', {
      sourcePath,
      destinationPath
    });
    if (!result.success) {
      throw new Error(result.error);
    }
  },

  async copyFileOrFolder(sourcePath: string, destinationPath: string): Promise<void> {
    const result = await window.electron.ipcRenderer.invoke('copy-file-or-folder', {
      sourcePath,
      destinationPath
    });
    if (!result.success) {
      throw new Error(result.error);
    }
  },

  async createDirectory(dirPath: string): Promise<void> {
    const result = await window.electron.ipcRenderer.invoke('create-directory', dirPath);
    if (!result.success) {
      throw new Error(result.error);
    }
  },

  async deleteFileOrFolder(path: string): Promise<{ success: boolean; error?: string }> {
    const result = await window.electron.ipcRenderer.invoke('delete-file-or-folder', path);
    return result;
  },

  async renameFileOrFolder(oldPath: string, newPath: string): Promise<void> {
    const result = await window.electron.ipcRenderer.invoke('rename-file-or-folder', { oldPath, newPath });
    if (!result || typeof result !== 'object' || !('success' in result)) {
      throw new Error('IPC response is undefined or invalid');
    }
    if (!result.success) {
      throw new Error(result.error);
    }
  },

  async revealInExplorer(filePath: string): Promise<void> {
    await window.electron.ipcRenderer.invoke('reveal-in-explorer', filePath);
  },

  async restartAsAdmin(): Promise<void> {
    const result = await window.electron.ipcRenderer.invoke('restart-as-admin');
    if (!result.success) {
      throw new Error(result.error);
    }
  }
}; 